import {
  FormFlowConfig,
  FormFlowConfigResult
} from '../../../types/registrationCheckout';
import { simCardType } from '../../../config/simcard-types';

export const getFormConfigForReconFlow = ({
  isNric,
  device,
  isCis,
  isCISMyInfoFlow = false,
  eBill,
  isNricSilver = false,
  hasSimCard = false,
  hasAccessories = false,
  simType
}: FormFlowConfig): FormFlowConfigResult => {
  let showStaffUploadDocument, byPassDocUpload;
  if (!isCis) {
    showStaffUploadDocument = false;
    byPassDocUpload = true;
  } else {
    showStaffUploadDocument = !!isCis && !isCISMyInfoFlow;
    byPassDocUpload =
      (eBill && !isCis && !isNricSilver && !!isNric) ||
      (eBill && isCISMyInfoFlow);
  }
  const showNricFIN = false;
  const showBillingPref = !eBill;
  const byPassFulfilment =
    !device &&
    (!hasSimCard || simType === simCardType.simTypeESim) &&
    !hasAccessories;

  return {
    showStaffUploadDocument,
    showNricFIN,
    showBillingPref,
    showExistingBillingAddress: false,
    byPassDocUpload,
    byPassFulfilment
  };
};
